// extracted by mini-css-extract-plugin
export default {"pagerContainer":"Foot_pagerContainer__RYgLY","nextBtn":"Foot_nextBtn__Ml20W","prevBtn":"Foot_prevBtn__KIJH8","loading":"Foot_loading__gqPXB"};